import { Col, Image, Row, Typography } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../../../../assets/icons/scribex-erp-logo.svg';
import { ADMIN_ROUTES } from '../../../../../constants/routes';
import styles from '../../signIn/styles.module.scss';

const {Text} = Typography;

interface WarehouseAuthContainerProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  bottomLinkText?: string;
  bottomLinkAction?: () => void;
  showERPLink?: boolean;
}

export const WarehouseAuthContainer: React.FC<WarehouseAuthContainerProps> = ({
                                                                                title,
                                                                                description,
                                                                                children,
                                                                                bottomLinkText,
                                                                                bottomLinkAction,
                                                                                showERPLink = false,
                                                                              }) => {
  const navigate = useNavigate();

  const handleAdminLogin = () => {
    navigate(ADMIN_ROUTES.adminSignIn);
  };

  return (
    <>
      <Row className={styles.logo_mobile}>
        <Image width={144} src={logo} alt="Logo" preview={false}/>
      </Row>
      <Row wrap={true} className={styles.signup}>
        <Col span={24}>
          <Row justify="center" className={styles.left_side} align="top">
            <Col sm={24} xs={24} className={styles.form}>
              <Row gutter={[0, 24]}>
                <Col span={24} className={styles.logo_desktop}>
                  <Image width={144} src={logo} alt="Logo" preview={false}/>
                </Col>
                <Col span={24}>
                  <Text className={styles.title}>{title}</Text>
                </Col>
                {description && (
                  <Col span={24}>
                    <Text className={styles.description}>{description}</Text>
                  </Col>
                )}
                <Col span={24}>{children}</Col>
                <Row className={styles.erp_link_container}>
                  {bottomLinkText && bottomLinkAction && (
                    <span onClick={bottomLinkAction} className={styles.erp_link}>
                      <Text style={{color: '#05796B'}}>{bottomLinkText}</Text>
                    </span>
                  )}
                  {showERPLink && (
                    <span onClick={handleAdminLogin} className={styles.erp_link}>
                      <Text style={{color: '#05796B'}} underline>
                        Log in into ERP System
                      </Text>
                    </span>
                  )}
                </Row>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default WarehouseAuthContainer;
